import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Zap, Users } from 'lucide-react';

const services = [
  { title: 'أنظمة حصرية', desc: 'برمجيات متقدمة ومطورة خصيصاً لتناسب تجربة الحياة الواقعية داخل اللعبة.', icon: <Zap size={36} /> },
  { title: 'بيئة عادلة', desc: 'قوانين صارمة ورقابة مستمرة لضمان تجربة خالية من التخريب والهاكات.', icon: <ShieldCheck size={36} /> },
  { title: 'مجتمع نشط', desc: 'فعاليات مستمرة، قطاعات حكومية متكاملة، وإدارة متواجدة على مدار الساعة.', icon: <Users size={36} /> },
];

export default function Services() {
  return (
    <section id="المميزات" className="pt-32 pb-24 min-h-screen relative">
      <div className="absolute left-0 top-0 w-64 h-64 bg-neon-cyan/10 rounded-full blur-[100px] pointer-events-none"></div>
      <div className="container mx-auto px-6 z-10 relative">
        <h2 className="text-4xl md:text-5xl font-bold text-center mb-20 text-white">ماذا <span className="text-neon-cyan">يُميزنا</span>؟</h2>
        <div className="grid md:grid-cols-3 gap-8">
          {services.map((srv, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.2 }}
              className="relative p-10 rounded-3xl hover:shadow-neon-cyan hover:-translate-y-2 transition-all duration-300 overflow-hidden group"
            >
              <div className="absolute inset-[-100%] bg-[conic-gradient(from_0deg,transparent_70%,#00f3ff_80%,#bc13fe_100%)] animate-[spin_3s_linear_infinite] opacity-0 group-hover:opacity-100 transition-opacity duration-500 z-0" />
              <div className="absolute inset-[2px] bg-[#050505]/95 backdrop-blur-xl rounded-[calc(1.5rem-2px)] z-0" />

              <div className="relative z-10 w-16 h-16 rounded-2xl bg-neon-cyan/10 flex items-center justify-center text-neon-cyan mb-6">
                {srv.icon}
              </div>
              <h3 className="relative z-10 text-2xl font-bold mb-4 text-white">{srv.title}</h3>
              <p className="relative z-10 text-gray-400 leading-relaxed">{srv.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}